'use strict';

const jQuery = require('jquery');

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const menuMobile = require('./../../../services/structure/menu/mobile');
const loader = require('./../../../services/loader');
const appender = require('./../service/appender');
const alert = require('./../../../services/alert');
const Translator = require('./../../../core/translator');
const Mediator = require('./../../../core/mediator');
const ContentScroller = require('./service/contentScroller');

const zoneClass = 'move-mobile-content';

module.exports.onClick = function(data) {
    let content = data.params.content;
    let doStuff = false;
    let parent = content.getParent();
    let $menu = jQuery('.cloud-menu');
    let rootContentSet = ContentManager.getRootContentSet();
    let onTouchEnd = function() {
            let config = {};
            let $zone = jQuery(this);

            if (doStuff) {
                $zone.addClass('active');

                loader.start();

                config.next = $zone.next();
                config.prev = $zone.prev();
                config.$zone = $zone;

                appender.horizontal(rootContentSet, content, config).done(function() {
                    $menu.removeClass('d-none');
                    SaveManager.save();

                    jQuery('.' + zoneClass).remove();
                    loader.stop();
                    alert.hide();

                    content.removeClass('cloud-highlight-move');

                    Mediator.publish('after:content:drop');
                    Mediator.publish('after:' + content.type + ':drop', content);

                    ContentScroller.scroll(content);
                });
            }
        };
    let onTouchMove = function() {
            doStuff = false;
        };
    let onTouchStart = function() {
            doStuff = true;
        };

    content.addClass('cloud-highlight-move');

    alert.show(Translator.translate('choose_content_location'), function() {
        jQuery('.' + zoneClass).remove();
        $menu.removeClass('d-none');
        content.removeClass('cloud-highlight-move');
        alert.hide();
    });

    $menu.addClass('d-none');

    rootContentSet.$.children('.bb-content').each(function(index) {
        let $current = jQuery(this);
        let $div = jQuery('<div class="' + zoneClass + '">' + Translator.translate('move_content_mobile') + '</div>');
        let $cloneDiv = $div.clone();

        if ($current.next('.bb-content').is(parent.$) || $current.is(parent.$)) {
            $div.addClass('d-none');
        }

        if ($current.prev('.bb-content').is(parent.$)) {
            $cloneDiv.addClass('d-none');
        }

        $div.on('touchstart MSPointerDown', onTouchStart);
        $div.on('touchmove MSPointerMove', onTouchMove);
        $div.on('touchend MSPointerUp', onTouchEnd);

        $current.after($div);

        if (index === 0) {
            if ($current.is(parent.$)) {
                $cloneDiv.addClass('d-none');
            }

            $cloneDiv.on('touchstart MSPointerDown', onTouchStart);
            $cloneDiv.on('touchmove MSPointerMove', onTouchMove);
            $cloneDiv.on('touchend MSPointerUp', onTouchEnd);
            $current.before($cloneDiv);
        }
    });

    menuMobile.close();

    ContentScroller.scroll(content);
};
